const steps = [
  {
    num: "01",
    icon: "ri-building-4-line",
    title: "기업 유형 선택",
    desc: "뮤직 레이블, 공연기획사, 문화재단, 웹툰·IP 스튜디오, 광고·콘텐츠 에이전시 중 수업 목표에 맞는 기업 유형을 선택합니다.",
    detail: "유형마다 전용 업무 허브, 고유 KPI 지표, 이해관계자 AI NPC가 다르게 구성됩니다.",
    accent: "#4B6CF7",
  },
  {
    num: "02",
    icon: "ri-briefcase-line",
    title: "직무 역할 선택",
    desc: "선택한 기업 유형에 맞는 5개 직무 중 하나를 맡습니다. 직무별로 접근 가능한 메뉴와 결재 권한이 완전히 다릅니다.",
    detail: "전체 16가지 고유 직무 역할 — 대표이사부터 데이터 분석가까지, 실제 직함 그대로 적용됩니다.",
    accent: "#7C3AED",
  },
  {
    num: "03",
    icon: "ri-dashboard-3-line",
    title: "대시보드 & 업무 수행",
    desc: "대시보드에서 자본금·KPI를 파악하고, 인박스 협상·전자결재·재무 ERP·직무별 허브를 통해 실무 업무를 처리합니다.",
    detail: "계약서 기안 → 재무 검토 → 대표 최종 결재까지 실제 기업 결재 라인이 그대로 구현됩니다.",
    accent: "#059669",
  },
  {
    num: "04",
    icon: "ri-flashlight-line",
    title: "랜덤 이벤트 대응",
    desc: "강사가 발송하는 위기·기회 이벤트에 팀 전체가 대응합니다. 선택지마다 자본금·명성·신용도가 실시간으로 변동됩니다.",
    detail: "12가지 이벤트 × 3가지 선택지 = 36가지 분기 — SNS 논란, VC 투자 제안, 세무조사 등 실전 시나리오.",
    accent: "#D97706",
  },
  {
    num: "05",
    icon: "ri-bar-chart-grouped-line",
    title: "강사 모니터링 & 피드백",
    desc: "강사는 God Mode 대시보드에서 전체 팀의 자본금·결재 내역·이벤트 선택 결과를 실시간으로 비교하며 피드백을 제공합니다.",
    detail: "팀 간 의사결정 차이를 수업 토론 주제로 활용 — 경영 감각을 객관적 데이터로 측정합니다.",
    accent: "#E11D48",
  },
];

const stats = [
  { icon: "ri-building-4-line", num: "5가지",  label: "기업 유형",           accent: "#4B6CF7" },
  { icon: "ri-user-line",        num: "16가지", label: "직무 역할",           accent: "#7C3AED" },
  { icon: "ri-flashlight-line",  num: "36+",   label: "의사결정 시나리오",   accent: "#D97706" },
  { icon: "ri-team-line",        num: "20인",  label: "최대 팀 구성",        accent: "#059669" },
];

const PD = "'Pretendard Variable', Pretendard, -apple-system, BlinkMacSystemFont, sans-serif";

export default function HowItWorksSection() {
  return (
    <>
      {/* How It Works */}
      <section id="how-it-works" className="bg-white py-16 md:py-24 lg:py-32" style={{ fontFamily: PD }}>
        <div className="max-w-6xl mx-auto px-4 sm:px-6">
          <div className="text-center mb-16">
            <div className="inline-flex items-center gap-2 text-[#4B6CF7] text-xs font-medium uppercase tracking-widest mb-4 bg-[#4B6CF7]/[0.07] px-3 py-1.5 rounded-full border border-[#4B6CF7]/15">
              <i className="ri-map-pin-line text-xs"></i> How It Works
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-[#111111] mb-4" style={{ fontFamily: PD }}>
              5단계로 시작하는 실전 교육
            </h2>
            <p className="text-[#888888] text-base max-w-xl mx-auto">
              기업 유형 선택부터 강사 피드백까지, 실제 기업 경영 흐름 그대로 진행됩니다.
            </p>
          </div>

          {/* Steps */}
          <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-3">
            {steps.map((step, i) => (
              <div key={i} className="relative">
                {i < steps.length - 1 && (
                  <div className="hidden lg:flex absolute top-[28px] left-[calc(100%-6px)] w-[12px] items-center z-10">
                    <div className="w-full h-px bg-black/[0.08]" />
                    <i className="ri-arrow-right-s-line text-[#CCCCCC] text-xs -ml-1 shrink-0" />
                  </div>
                )}
                <div
                  className="bg-white border border-black/[0.08] rounded-2xl p-5 h-full hover:border-black/[0.14] transition-all group"
                  style={{ borderTop: `2px solid ${step.accent}35` }}
                >
                  <div className="flex items-center gap-2.5 mb-4">
                    <span
                      className="text-3xl font-black tabular-nums leading-none"
                      style={{ fontFamily: PD, color: `${step.accent}22` }}
                    >
                      {step.num}
                    </span>
                    <div
                      className="w-7 h-7 flex items-center justify-center rounded-lg shrink-0"
                      style={{ background: `${step.accent}12`, border: `1px solid ${step.accent}25` }}
                    >
                      <i className={`${step.icon} text-xs`} style={{ color: step.accent }}></i>
                    </div>
                  </div>
                  <h4 className="text-[#111111] font-semibold text-sm mb-2 leading-tight" style={{ fontFamily: PD }}>
                    {step.title}
                  </h4>
                  <p className="text-[#888888] text-xs leading-relaxed mb-3">{step.desc}</p>
                  <p
                    className="text-[10px] leading-relaxed border-t border-black/[0.06] pt-3"
                    style={{ color: step.accent, opacity: 0.65 }}
                  >
                    {step.detail}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Stats Banner */}
      <section className="bg-[#F9F9F9] border-y border-black/[0.07] py-14" style={{ fontFamily: PD }}>
        <div className="max-w-4xl mx-auto px-6">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            {stats.map((s) => (
              <div key={s.label} className="text-center">
                <div
                  className="w-10 h-10 flex items-center justify-center rounded-xl mx-auto mb-3 border"
                  style={{ backgroundColor: `${s.accent}10`, borderColor: `${s.accent}25` }}
                >
                  <i className={`${s.icon} text-base`} style={{ color: s.accent }}></i>
                </div>
                <div className="text-3xl font-bold text-[#111111] mb-1 tabular-nums" style={{ fontFamily: PD }}>
                  {s.num}
                </div>
                <div className="text-[#888888] text-xs">{s.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
